import { render, staticRenderFns } from "./WechatMenu.vue?vue&type=template&id=019390ad"
import script from "./WechatMenu.vue?vue&type=script&lang=js"
export * from "./WechatMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports